import  {baseActions}  from "./base.actions";

export const certificationTypeGroupActions = {
   
    gets,
    get,
    
};


function gets() {
    return baseActions.getall('certificationtypegroup');
}

function get(id)
{
    return baseActions.get('certificationtypegroup',id);
}
